import { render, staticRenderFns } from "./moban.vue?vue&type=template&id=5914ffb0&scoped=true&"
import script from "./moban.vue?vue&type=script&lang=ts&"
export * from "./moban.vue?vue&type=script&lang=ts&"
import style0 from "./moban.vue?vue&type=style&index=0&id=5914ffb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914ffb0",
  null
  
)

export default component.exports